import {
  createFieldDataModel,
  createFieldFormConfigDataModel,
  FieldEntity,
  IField,
  ISelectConfig,
  ITextFieldConfig,
  KpiTemplateSectionType,
} from '../../../data-models/field2.data-model';
import { RendererType } from '../../../data-models/field-definition';
import { PrimitiveType } from '../../../data-models/field3.data-model';
import {
  createKPITemplateSectionDataModel,
  IKPITableDataModel,
  ITextualKpiTemplateSectionMeta,
} from '../../../data-models/kpi-template.data-model';
import { Formatting } from '../../../types';
import { KpiSection } from '../../../data-models/company-financials.data-model';

export function createKPIItemByType(
  sectionType: string,
  nonTextualUniversalKpis: IField<unknown>[],
  textualKpis: IField<unknown>[]
) {
  let sectionMeta: IField<unknown> | IKPITableDataModel | ITextualKpiTemplateSectionMeta;

  switch (sectionType) {
    case RendererType.multiSelect:
      sectionMeta = createFieldDataModel<string, ISelectConfig<string>>({
        entity: 'template',
        entityField: 'New Question',
        type: RendererType.multiSelect,
        formMeta: createFieldFormConfigDataModel<string, ISelectConfig<string>>({
          required: false,
          renderer: {
            type: RendererType.multiSelect,
            config: {
              placeholder: 'Select options',
              multi: true,
              values: [],
            },
          },
        }),
      });
      break;

    case RendererType.fileUpload:
      sectionMeta = createFieldDataModel<string, ITextFieldConfig>({
        entity: 'template',
        entityField: 'New File',
        description: 'Select file to upload your financial data',
        type: RendererType.fileUpload,
        formMeta: createFieldFormConfigDataModel<string, ITextFieldConfig>({
          required: false,
          renderer: {
            type: RendererType.fileUpload,
            config: {
              placeholder: 'info',
              maxLength: -1,
            },
          },
        }),
      });
      break;

    case RendererType.kpiTable:
      sectionMeta = {
        displayName: 'Universal KPIs',
        description: '',
        metrics: [],
        section: KpiSection.actual,
      } as IKPITableDataModel;
      break;

    case RendererType.universalKpiTable:
      sectionMeta = {
        displayName: 'Universal KPIs',
        description: '',
        metrics: [...nonTextualUniversalKpis],
        section: KpiSection.actual,
      } as IKPITableDataModel;
      break;

    case RendererType.text: {
      sectionMeta = {
        kpiConfig: textualKpis.at(0) ?? createFieldDataModel<unknown>(),
        section: KpiSection.actual,
      };

      break;
    }
    default:
      throw new Error(`Unexpected section type: ${sectionType}`);
  }
  let type: KpiTemplateSectionType = KpiTemplateSectionType.field;
  if (sectionType === RendererType.kpiTable || sectionType === RendererType.universalKpiTable) {
    type = KpiTemplateSectionType.grid;
  } else if (sectionType === RendererType.text) {
    type = KpiTemplateSectionType.textualKpi;
  }

  return createKPITemplateSectionDataModel({
    type,
    templateId: -1,
    meta: sectionMeta,
  });
}

export function createKPIField(name: string, unit: Formatting) {
  return createFieldDataModel({
    entity: FieldEntity.userKPI,
    displayName: name,
    entityField: name,
    formMeta: {
      renderer: {
        type: unit,
        id: unit,
        config: {},
      },
      formatter: {
        id: unit,
        type: unit as unknown as PrimitiveType, // FIXME: Remove once MAGGIE-6958 is completed
        config: {},
      },
      required: false,
      defaultValue: null,
    },
    type: 'number',
  });
}
